import { render, staticRenderFns } from "./VSlides.vue?vue&type=template&id=7a3f7346"
import script from "./VSlides.vue?vue&type=script&lang=js"
export * from "./VSlides.vue?vue&type=script&lang=js"
import style0 from "./VSlides.vue?vue&type=style&index=0&id=7a3f7346&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports